import { IGlobalSignalrGroupResponse } from "@miplatform/types";
import { create } from "zustand";
import { devtools } from 'zustand/middleware';

export type IGlobalSignalrGroupState = Omit<
  IGlobalSignalrGroupResponse,
  "GroupName"
>;

export type GlobalSignalrGroupsState = Record<
  string,
  Partial<IGlobalSignalrGroupState>
>;

export interface IGlobalSignalrGroupsStore {
  connectionState?: string;
  groups: GlobalSignalrGroupsState;
  setConnectionState: (state: string) => void;
  setGroupResult: (groupName: string, result: object) => void;
  setGroupsState: (groups: IGlobalSignalrGroupResponse[]) => void;
}

export const useGlobalSignalrGroupsStore = create<IGlobalSignalrGroupsStore>()(
  devtools((set) => ({
    groups: {},
    setConnectionState: (state: string) => set({ connectionState: state }),
    setGroupResult: (groupName: string, result: object) =>
      set((current) => ({
        groups: {
          ...current.groups,
          [groupName]: { ...current.groups[groupName], result },
        },
      })),
    setGroupsState: (groups: IGlobalSignalrGroupResponse[]) =>
      set((current) => ({
        groups: {
          ...current.groups,
          ...Object.fromEntries(
            groups.map(({ groupName, ...rest }) => [groupName, rest])
          ),
        },
      })),
  })
));

export default useGlobalSignalrGroupsStore;